import { __spreadArray } from "tslib";
import { BlockReasons } from './types';
import { reduxKey } from './constants';
import { getIsLoggedIn, getShowMatureContent, } from '../../publicSession/selectors';
function getModerationState(state) {
    return (state[reduxKey] || { deviations: {}, users: {} });
}
/** Used only for stories */
export function getIsUserBlocked(state, userId, defaultValue) {
    if (defaultValue === void 0) { defaultValue = false; }
    var userState = getModerationState(state).users[userId];
    return userState ? userState.isBlocked : defaultValue;
}
/**
 * Recreates the block reasons for deviation on client side.
 * Ingnores the isBlocked field in deviation as it can be stale.
 *
 * Uses moderation state for user and deviation to build correct state
 * on client.
 *
 * For mature and antisocial deviations adds the reasons in cached deviations
 * if they are missing.
 */
export function getBlockTypesForDeviation(state, _a) {
    var deviationId = _a.deviationId, author = _a.author, _b = _a.blockReasons, blockReasons = _b === void 0 ? [] : _b, isAntisocial = _a.isAntisocial, isMature = _a.isMature;
    var types = __spreadArray([], blockReasons);
    // if we have relevant state for this deviation, the answer is obvious
    var userState = author && getModerationState(state).users[author.userId];
    if (userState) {
        var isUserBlocked = types.includes(BlockReasons.ArtistBlocked);
        // user blocked the artist on the client side
        if (!isUserBlocked && userState.isBlocked) {
            types.push(BlockReasons.ArtistBlocked);
        }
        // user unblocked the artist on the client side
        if (isUserBlocked && !userState.isBlocked) {
            types = types.filter(function (t) { return t !== BlockReasons.ArtistBlocked; });
        }
    }
    var deviationState = getModerationState(state).deviations[deviationId];
    if (deviationState) {
        var isDeviationBlocked = types.includes(BlockReasons.DeviationBlocked);
        if (deviationState.isBlocked && !isDeviationBlocked) {
            types.push(BlockReasons.DeviationBlocked);
        }
        // if it was deviation blocked, we override that
        if (!deviationState.isBlocked && isDeviationBlocked) {
            types = types.filter(function (t) { return t !== BlockReasons.DeviationBlocked; });
        }
    }
    // check for mature filter client side
    if (isMature &&
        !getShowMatureContent(state) &&
        !types.includes(BlockReasons.MatureFilter)) {
        types.push(BlockReasons.MatureFilter);
    }
    // extra check for anti-social because inside a saved editor
    // deviation we can have stale isBlocked value
    if (isAntisocial &&
        !getIsLoggedIn(state) &&
        !types.includes(BlockReasons.Antisocial)) {
        types.push(BlockReasons.Antisocial);
    }
    return types;
}
var blockReasonPriority = [
    BlockReasons.Antisocial,
    BlockReasons.MatureLoggedOut,
    BlockReasons.BlockedByArtist,
    BlockReasons.ArtistBlocked,
    BlockReasons.DeviationBlocked,
    BlockReasons.StrictMatureAge,
    BlockReasons.MatureAge,
    BlockReasons.MatureFilter,
];
export function getHighestPriorityBlockReasonForDeviation(state, deviation) {
    var blockReasons = getBlockTypesForDeviation(state, deviation);
    return blockReasonPriority.find(function (reason) { return blockReasons.includes(reason); });
}
//# sourceMappingURL=selectors.js.map